import { render } from "./App.vue?vue&type=template&id=60c97c4f&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=60c97c4f&lang=css"

import exportComponent from "/home/taiko/Documents/irdtechbook_cloudflare/test/pages-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__